import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Unstable_Grid2";
import Usercard from "./Usercard";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
export default function MaingridRight(props) {
  const [paginationCount, setPaginationCount] = useState(1);

  const dataset = props.dataset;

  useEffect(() => {
    setPaginationCount(Math.ceil(dataset.length / 12));
  }, [props.dataset]);

  const allStudents = dataset.length ? (
    dataset
      .slice((props.currentPage - 1) * 12, (props.currentPage - 1) * 12 + 12)
      .map((student, index) => {
        return (
          <Grid xs={1} key={student + index}>
            <Usercard
              prevYr={props.prevYr}
              key={student[1]}
              studentName={student[4]}
              itemIndex={index}
              studentID={student[1]}
              absentToday={student[96].length > 0}
              studentClass={student[5]}
              studentGender={student[69]}
              setTooltipStatus={props.setTooltipStatus}
              tooltipPrevSet={props.tooltipPrevSet}
              hebrewName={student[6]}
              refreshToken={props.refreshToken}
              changeStudentEmojiTag={props.changeStudentEmojiTag}
              customEmojiTag={props.customEmojiTag}
              imageDriveUrl={student[student.length - 3]}
              setHelpOpen={props.setHelpOpen}
              newStudent={props.newStudent}
              parentEmails={student[39]}
              studentEmail={student[34]}
              setNewImageBlob={props.setNewImageBlob}
              imageBlobs={props.imageBlobs}
              isNewToBialik={student[41] != "" && !student[5].includes("JK")}
              getAppCheckToken={props.getAppCheckToken}
              selectedTerm={props.filterOptions["Term"]}
              photoReleaseAllowed={student[55] == "No"}
              birthdate={student[56]}
              householdId={student[83]}
              gsAvg={
                ((Number(student[16]) || 0) + (Number(student[18]) || 0)) /
                  ((student[16] && 1) + (student[18] && 1)) || false
              }
              jsAvg={
                ((props.filterOptions["Term"] == "JS Average" ||
                  props.filterOptions["Term"] == "GS Average") &&
                  (((Number(student[17]) || 0) + (Number(student[19]) || 0)) /
                    ((student[17] && 1) + (student[19] && 1)) ||
                    false)) ||
                Number(
                  props.termMarksAvg(student)[
                    props
                      .termMarksAvg(student)
                      .indexOf(props.filterOptions["Term"]) + 1
                  ],
                ) ||
                false
              }
              anaphylaxis={student[46] == "Yes"}
              tags={[
                ["IEP", student[22] != ""],
                ["GP", student[23] != ""],
                ["SSF", student[25] != ""],
                [
                  "Ivrit Regular Shiluv",
                  student[29].includes("26/27:Ivrit Regular"),
                ],
                [
                  "Ivrit Occasional Shiluv",
                  student[29].includes("26/27:Ivrit Occasional Shiluv"),
                ],
                [
                  "Ivrit Regular/Occasional Shiluv",
                  student[29].includes(
                    "26/27:Ivrit Occasional / Regular Shiluv",
                  ),
                ],
                [
                  "Tanach Regular Shiluv",
                  student[29].includes("26/27:Tanach Regular"),
                ],
                [
                  "Tanach Occasional Shiluv",
                  student[29].includes("26/27:Tanach Occasional Shiluv"),
                ],
                [
                  "Tanach Regular/Occasional Shiluv",
                  student[29].includes(
                    "26/27:Tanach Occasional / Regular Shiluv",
                  ),
                ],
                ["Ulpan", student[28].includes("26/27")],
                ["Asthma", student[48] == "Yes"],
                ["Serious Condition", student[50] == "Yes"],
                ["Ivrit MOD", student[57].includes("MOD")],
                ["Tanach MOD", student[58].includes("MOD")],
                ["ELL", student[59] != ""],
                ["PTA Parent", student[68].includes("PTA Parent")],
                [
                  "Divorced Household",
                  student[68].includes("Divorced Household"),
                ],
                ["Staff Child", student[68].includes("Staff child (Current)")],
                [
                  "Former Staff Child",
                  student[68].includes("Staff child (Former)"),
                ],
                ["Deaf Parent", student[68].includes("Deaf Parent")],
                [
                  "Both Parents Must Be Contacted",
                  student[68].includes("Both Parents Must Be Contacted"),
                  "",
                  "#ff5e00ff",
                ],
                ["Board Parent", student[68].includes("Board Parent")],

                ["Kippah Yes", student[60] == "Wear"],
                ["Kippah No", student[60] == "Not wear"],
                ["Male", student[69] == "Male"],
                ["Female", student[69] == "Female"],
                ["Kippah Student", student[60] == "Up to child"],
                [
                  "BGW",
                  student[67] == "Ben Gurion Weizmann",
                  "#d44f46",
                  "#ffffff",
                ],
                ["HT", student[67] == "Haifa Technion", "#64ab2e", "#ffffff"],
                [
                  "HU",
                  student[67] == "Hebrew University",
                  "#000000",
                  "#e0bd22",
                ],
                [
                  "No Field Trip Permission",
                  student[88] != "Yes",
                  "#880000ff",
                  "#FFFFFF",
                ],
                ["BITA", student[67] == "Bar Ilan Tel Aviv", "#FFD700"],
              ]}
            />
          </Grid>
        );
      })
  ) : (
    <Grid xs={4}>
      <h3 className="centerPagination"> {props.loaded && "No Results"} </h3>
    </Grid>
  );

  const pagiChange = function (newPage) {
    props.setCurrentPage(newPage);
  };

  return (
    <Grid container spacing={2} columns={{ xl: 4, lg: 3, xs: 1, sm: 2, md: 2 }}>
      {allStudents}

      {dataset.length && (
        <Grid xs={4}>
          <div className="centerPagination">
            <Pagination
              onChange={(event, page) => {
                pagiChange(page);
              }}
              count={paginationCount}
              color="primary"
              page={props.currentPage}
            />
          </div>
        </Grid>
      )}
    </Grid>
  );
}
